import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./../styles/header.css";
import header_image from "../assets/images/header/caricatura2.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isHome = location.pathname === "/";

  const goToBlog = () => {
    setIsMenuOpen(false);
    window.location.href = "/blog";
  };

  return (
    <header className={`header ${scrolled ? "scrolled" : ""}`}>
      <div id="container">

        {/* Logo */}
        <div className="logo-with-text">
          <Link to="/" className="logo-link">
            <img src={header_image} alt="Logo" />
          </Link>
          <div className="logo-text">
            <h1 className="logo-title">Psicólogo Marcelo Martins</h1>
            <p className="logo-subtitle">Psicólogo licenciado</p>
            <p className="logo-subtitle">CRP 06/123896</p>
          </div>
        </div>

        {/* Ícone Menu Hamburguer */}
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={`fa ${isMenuOpen ? "fa-times" : "fa-bars"}`}></i>
        </div>

        {/* Navegação */}
        <nav className={`nav ${isMenuOpen ? "active" : ""}`}>
          <ul className="nav-list">
            <li><Link to="/" className="nav-item" onClick={() => setIsMenuOpen(false)}>Início</Link></li>
            <li><a href="/#about" className="nav-item" onClick={() => setIsMenuOpen(false)}>Sobre</a></li>
            <li><a href="/#plans" className="nav-item" onClick={() => setIsMenuOpen(false)}>Atendimentos</a></li>
            <li><a href="/#faq" className="nav-item" onClick={() => setIsMenuOpen(false)}>FAQ</a></li>
            <li><a href="/#contact" className="nav-item" onClick={() => setIsMenuOpen(false)}>Agendamento</a></li>
            <li><Link to="/blog" className="nav-item" onClick={goToBlog}>Blog</Link></li>
          </ul>
          
        </nav>

      </div>
    </header>
  );
};

export default Header;
